import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

async function createIntent({ amountCents, customerEmail, metadata }) {
  const res = await fetch("/createPaymentIntent", { // proxy to your CF URL via dev proxy or rewrite
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      amount: amountCents,
      currency: "usd",
      customerEmail,
      metadata
    })
  });
  if (!res.ok) throw new Error("Failed to create PaymentIntent");
  return res.json();
}

function Inner({ amountCents, email, metadata, onPaid }) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {},
      redirect: "if_required"
    });
    setSubmitting(false);
    if (error) {
      alert(error.message || "Payment failed");
      return;
    }
    if (paymentIntent && paymentIntent.status === "succeeded") {
      onPaid(paymentIntent);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button disabled={!stripe || submitting} style={{ marginTop: 12 }}>
        {submitting ? "Processing…" : "Pay now"}
      </button>
    </form>
  );
}

export default function PaymentBox({ amountCents, email, metadata = {}, onPaid }) {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    let stop = false;
    (async () => {
      const { clientSecret } = await createIntent({ amountCents, customerEmail: email, metadata });
      if (!stop) setClientSecret(clientSecret);
    })();
    return () => { stop = true; };
  }, [amountCents, email, metadata]);

  if (!clientSecret) return <p>Loading payment…</p>;

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <Inner amountCents={amountCents} email={email} metadata={metadata} onPaid={onPaid} />
    </Elements>
  );
}
